/* eslint-disable react/require-default-props */
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Link, Modal } from '@express-labs/raven-ui';
import { getPath } from '@express-labs/raven-tools';
import OffersModalDetail from './OffersModalDetail';

import s from './OffersModal.module.scss';
import AddCodeButton from '../AddCodeButton';
import { showCta } from '../../../../../../helpers/offersModalsHelpers/offersModalsHelpers';
import OfferDetails from '../OfferDetails';

function OffersModal({
  onClose, globalOffers, personalizedOffers, appliedCode,
}) {
  const [offerDetail, setOfferDetail] = useState({});
  const [openDetail, setOpenDetail] = useState(false);

  const toggleDetail = useCallback((offer) => {
    setOfferDetail(offer);
    setOpenDetail(!openDetail);
  }, [openDetail]);

  const offerDetails = (offers) => offers.map((offer) => {
    const backgroundImage = getPath(offer, 'image.url', null);
    const promoCodeAdded = !!appliedCode && appliedCode === offer.crm_code;
    const headlineCharLimit = 40;
    const shortDescriptionCharLimit = 90;
    const headlineFormatted = offer.subheading && offer.subheading.length > headlineCharLimit
      ? `${offer.subheading.substr(0, headlineCharLimit)}...`
      : offer.subheading;
    const shortDescriptionFormatted = offer.short_description
      && offer.short_description.length > shortDescriptionCharLimit
      ? `${offer.short_description.substr(0, shortDescriptionCharLimit)}...`
      : offer.short_description;
    const showCta1 = showCta(offer.cta_1);
    const showCta2 = showCta(offer.cta_2);

    return (
      <div
        key={offer.crm_code}
        className={s.offerDetailsContent}
        style={{
          backgroundImage: `url("${backgroundImage}")`,
        }}
      >
        <OfferDetails
          headlineFormatted={headlineFormatted}
          offer={offer}
          shortDescriptionFormatted={shortDescriptionFormatted}
          toggleDetail={toggleDetail}
        />
        {offer.crm_code && (
          <AddCodeButton crmCode={offer.crm_code} promoCodeAdded={promoCodeAdded} />
        )}
        {(showCta1 || showCta2) && (
          <div className={s.ctas}>
            {showCta1 && (
              <Link
                as="a"
                theme="dark"
                size="secondary"
                href={offer.cta_1.href}
              >
                {offer.cta_1.title}
              </Link>
            )}
            {showCta2 && (
              <Link
                as="a"
                theme="dark"
                size="secondary"
                href={offer.cta_2.href}
              >
                {offer.cta_2.title}
              </Link>
            )}
          </div>
        )}
      </div>
    );
  });

  const containerStyle = openDetail
    ? [s.offerModalContainer, s.modaldetailContainer].join(' ')
    : s.offerModalContainer;

  const offers = openDetail ? (
    <OffersModalDetail
      appliedCode={appliedCode}
      offer={offerDetail}
      back={() => setOpenDetail(!openDetail)}
    />
  ) : (
    <div className={s.offersMainContainer}>
      {personalizedOffers.length > 0 && (
      <div className={s.offerContainer}>
        <div className={s.offerTitle}>
          Insider Offers&nbsp;(
          {personalizedOffers.length}
          )
        </div>
        <div className={s.offerSubTitle}>May only redeem one offer if code required.</div>
        <div className={s.offerSubContainer}>{offerDetails(personalizedOffers)}</div>
      </div>
      )}
      <div className={s.offerContainer}>
        <div className={s.offerTitle}>
          Today&apos;s Offers&nbsp;(
          {globalOffers.length}
          )
        </div>
        <div className={s.offerSubTitle}>May only redeem one offer if code required.</div>
        <div className={s.offerSubContainer}>{offerDetails(globalOffers)}</div>
      </div>
    </div>
  );

  return (
    <Modal
      isOpen
      onModalClose={onClose}
      shouldCloseOnOverlayClick={false}
      className={containerStyle}
      overlayClassName={s.modalOverlay}
    >
      {offers}
    </Modal>
  );
}

OffersModal.propTypes = {
  onClose: PropTypes.func,
  globalOffers: PropTypes.arrayOf(
    PropTypes.shape({
      crm_code: PropTypes.string,
      cta_1: {
        title: PropTypes.string,
      },
      cta_2: {
        title: PropTypes.string,
      },
      image: {
        url: PropTypes.string,
      },
      details_image: {
        url: PropTypes.string,
      },
      description: PropTypes.string,
      legal_text: PropTypes.string,
      title: PropTypes.string,
    }),
  ),
  personalizedOffers: PropTypes.arrayOf(PropTypes.shape({})),
  appliedCode: PropTypes.string,
};

export default OffersModal;
